export default () => ({ buildSHA: '66c7580bc6bf0981739bd802809f4fb03944ddbe' })
